import { QueryKey, useMutation, useQuery } from '@tanstack/react-query'
import axiosInstance from '../axios'

export const useApiGet = <T>(
  url: string,
  queryKey: QueryKey,
  config = {},
  enabled = true
) => {
  const fetchData = async (): Promise<T> => {
    const response = await axiosInstance.get(url, config)
    return response.data
  }

  return useQuery({
    queryKey,
    queryFn: fetchData,
    enabled,
  })
}

// 조회용 POST
export const useApiPostQuery = <T>(
  url: string,
  queryKey: QueryKey,
  data = {},
  enabled = true,
  options = {}
) => {
  const fetchData = async (): Promise<T> => {
    const response = await axiosInstance.post(url, data)
    return response.data
  }

  return useQuery({
    queryKey,
    queryFn: fetchData,
    enabled,
    retry: 0,
    ...options,
  })
}

// 변경용 POST
export const useApiPostMutation = <T, D = any>() => {
  const postData = async ({
    url,
    data,
    options = {},
  }: {
    url: string
    data: D
    options?: any
  }): Promise<T> => {
    const response = await axiosInstance.post(url, data, options)
    return response.data
  }

  return useMutation({
    mutationFn: postData,
  })
}

export const useApiPut = <T, D = any>(url: string, options = {}) => {
  const putData = async (data: D): Promise<T> => {
    const response = await axiosInstance.put(url, data, options)
    return response.data
  }

  return useMutation({
    mutationFn: putData,
  })
}

export const useApiDelete = <T>(url: string, options = {}) => {
  const deleteData = async (id: string | number): Promise<T> => {
    const response = await axiosInstance.delete(`${url}/${id}`, options)
    return response.data
  }

  return useMutation({
    mutationFn: deleteData,
  })
}
